import { baseApi, Http, rtkq, RtkqRequest } from '@app/base';
import { CreateGlaucomaTestsRequest, GlaucomaImageFile } from './glaucomaTestsTypes';

export const glaucomaTestsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    createGlaucomaTests: build.mutation<string, RtkqRequest<CreateGlaucomaTestsRequest>>({
      queryFn: rtkq.axios((args) => Http.post(`/api/encounter/${args.id}/glaucoma-tests`, args)),
      invalidatesTags: (_, __, { id }) => [{ type: 'medical-record:encounter', id }],
    }),

    getGlaucomaImages: build.query<GlaucomaImageFile[], RtkqRequest<{ id: string; teleportId: string }>>({
      queryFn: rtkq.axios(({ id, teleportId }) =>
        Http.get(`/api/encounter/${id}/glaucoma-tests/${teleportId}/glaucoma-images`),
      ),
      providesTags: (_, __, { id }) => [{ type: 'medical-record:encounter', id }],
    }),
  }),
});

export const { useCreateGlaucomaTestsMutation, useLazyGetGlaucomaImagesQuery } = glaucomaTestsApi;
